export type DataItemType = {
  [key: string]: any;
};

export const filterInData = (
  data: DataItemType[] | undefined,
  keys: string[],
  searchValue: string | undefined
): DataItemType[] => {
  if (!Array.isArray(data)) return [];
  if (!searchValue) return data;

  return data.filter((item) =>
    keys.some((key) => item[key]?.toString().toLowerCase().includes(searchValue.toLowerCase()))
  );
};

export const filterInDataByKeys = (
  data: DataItemType[] | undefined,
  criteria: Partial<DataItemType>,
  options?: { skipValues?: string[] }
): DataItemType[] => {
  if (!Array.isArray(data)) return [];

  const lowerSkipValues = (options?.skipValues || []).map((v) => v.toLowerCase());
  return data.filter((item) => {
    for (const key in criteria) {
      const filterValue = criteria[key];
      if (typeof filterValue === 'string' && lowerSkipValues.includes(filterValue.toLowerCase())) {
        continue;
      }
      const itemValue = item[key];
      if (Array.isArray(itemValue)) {
        if (!itemValue.includes(filterValue)) {
          return false;
        }
      } else {
        if (typeof itemValue === 'string' && typeof filterValue === 'string') {
          if (itemValue.toLowerCase() !== filterValue.toLowerCase()) {
            return false;
          }
        } else {
          if (itemValue !== filterValue) {
            return false;
          }
        }
      }
    }
    return true;
  });
};
